const messages = {
    title: "Générer le rapport",
    personal_data: {
        title: "Données personnelles",
        email: "E-mail",
        salutation: "Civilité",
        first_name: "Prénom",
        last_name: "Nom de famille",
        job_position: "Poste dans l'entreprise"
    },
    shipping_address: {
        title: "Adresse de livraison",
        company: "Nom de l'entreprise",
        street: "Numéro et rue",
        postal_code: "Code postal",
        mobile_phone: "Téléphone portable",
        iban_number: "IBAN",
        vat: "Numéro de TVA",
        additional_address: "Adresse complémentaire",
        city: "Ville"
    },
    calculatedData: 'Data type',
    operating_data: {
        title: "Données d'exploitation",
        customer_number: "Numéro client",
        group: "Groupe",
        customer_group: "Groupe",
        first_registration: "Première immatriculation",
        last_login: "Dernière connexion",
        tires_per_year: "Pneus par an",
        over_18_inch: "Plus de 18 pouces",
        premium: "Premium",
        middle: "Moyenne gamme",
        summer: "Été",
        winter: "Hiver",
        all_season: "Toutes saisons"
    },
    calculated_data: {
        title: "Données calculées",
        tireAmount: "Quantité de pneus",
        points: "Points",
        bonus: "Bonus"
    },
    sales_structure: {
        title: "Structure commerciale",
        sales_representative: {
            title: "Représentant commercial",
        },
        distributor: {
            title: "Distributeur",
        },
    },
    meta: {
        title: " ",
        brand: {
            title: "Marque",
            none: ''
        },
        tireType: {
            title: "Type de pneu",
            none: ''
        },
        year: {
            title: "Année",
            "2020": "2020",
            "2021": "2021",
            "2022": "2022",
            "2023": "2023",
            "2024": "2024",
            "2025": "2025"
        },
        calendarMonth: {
            title: "Mois du calendrier",
            january: "Janvier",
            february: "Février",
            march: "Mars",
            april: "Avril",
            may: "Mai",
            june: "Juin",
            july: "Juillet",
            august: "Août",
            september: "Septembre",
            october: "Octobre",
            november: "Novembre",
            december: "Décembre"
        },
    },
    selectAll: "Tout sélectionner",
    reset: "Réinitialiser les filtres",
    generate: "Générer le rapport",
    loadingInfo: "Génération du rapport, veuillez patienter...",
    downloadingTitle: "Téléchargement des détails des clients participants",
    filterInstruction: "Veuillez définir votre filtre de sélection :",
    downloads: "Téléchargements",
    validation: {
        distributorRequired: "Veuillez sélectionner au moins une option",
    }
};

export default {
    messages,
};
